/**
 * Global Application Configuration
 * Access environment variables baked into the build
 */

interface AppConfig {
  API_BASE_URL: string;
  API_TIMEOUT: number;
  TENANT_ID: number;
  LOGIN_URL: string;
  SIGNUP_URL: string;
  FORGOT_PASSWORD_URL: string;
  DASHBOARD_URL: string;
  LOGIN_REDIRECT_URL: string;
  LOGOUT_REDIRECT_URL: string;
  SIGNUP_REDIRECT_URL: string;
  PASSWORD_RESET_REDIRECT_URL: string;
  GOOGLE_CLIENT_ID?: string;
  DEBUG_MODE: boolean;
  LOG_LEVEL: string;
}

// Create global config from environment variables that are already baked into build
window.APP_CONFIG = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || '',
  API_TIMEOUT: parseInt(import.meta.env.VITE_API_TIMEOUT || '30000', 10),
  TENANT_ID: parseInt(import.meta.env.VITE_TENANT_ID || '1', 10),
  LOGIN_URL: import.meta.env.VITE_LOGIN_URL || '/?view=login',
  SIGNUP_URL: import.meta.env.VITE_SIGNUP_URL || '/?view=signup',
  FORGOT_PASSWORD_URL: import.meta.env.VITE_FORGOT_PASSWORD_URL || '/?view=forgot-password',
  DASHBOARD_URL: import.meta.env.VITE_DASHBOARD_URL || '/?view=dashboard',
  LOGIN_REDIRECT_URL: import.meta.env.VITE_LOGIN_REDIRECT_URL || '/?view=dashboard',
  LOGOUT_REDIRECT_URL: import.meta.env.VITE_LOGOUT_REDIRECT_URL || '/?view=login',
  SIGNUP_REDIRECT_URL: import.meta.env.VITE_SIGNUP_REDIRECT_URL || '/?view=login',
  PASSWORD_RESET_REDIRECT_URL: import.meta.env.VITE_PASSWORD_RESET_REDIRECT_URL || '/?view=login',
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
  DEBUG_MODE: import.meta.env.VITE_DEBUG_MODE === 'true',
  LOG_LEVEL: import.meta.env.VITE_LOG_LEVEL || 'info',
} as AppConfig;

// Freeze to prevent accidental modifications
Object.freeze(window.APP_CONFIG);

declare global {
  interface Window {
    APP_CONFIG: AppConfig;
  }
}

export const appConfig = window.APP_CONFIG;
